import { Injectable } from "@angular/core";
import { JwtHelperService } from "@auth0/angular-jwt";
import * as momentTimeZone from "moment-timezone";
import axios from "axios";
import { Router } from "@angular/router";

@Injectable()
export class AuthService {
  public isRefreshing: boolean = false;
  constructor(public jwtHelper: JwtHelperService, public router: Router) { }

  private getStoredToken(): string | null {
    return localStorage.getItem("token") || localStorage.getItem("userToken");
  }

  public isAuthenticated(): boolean {
    const token = this.getStoredToken();
    if (!token) {
      return false;
    }

    const expiryString = localStorage.getItem("tokenExpireDateTime");
    if (expiryString) {
      const expiryDate = new Date(expiryString);
      const now = momentTimeZone(new Date()).tz("Asia/Karachi").toDate();

      const seconds = (expiryDate.getTime() - now.getTime()) / 1000;
      // Refresh only when token is about to expire (next 10 minutes)
      if (seconds > 0 && seconds <= 2700 && !this.isRefreshing) {
        this.isRefreshing = true;
        const payload = {
          userToken: token,
        };
        axios
          .post("Account/RefreshToke", payload)
          .then((response) => {
            if (response.status === 200) {
              if (response.data.payload.userToken) {
                localStorage.setItem("token", response.data.payload.userToken);
                let expiarytime = null;
                expiarytime = new Date(response.data.payload.expiresIn);
                localStorage.setItem(
                  "tokenExpireDateTime",
                  expiarytime.toString()
                );
                this.isRefreshing = false;
              }
            } else {
              this.isRefreshing = false;
            }
          })
          .catch(() => {
            this.isRefreshing = false;
          });
      }
    }

    return !this.jwtHelper.isTokenExpired(token);
  }

  public convertTimeToSeconds(date: Date): number {
    const toConvert = new Date(date);

    const hoursInSec = toConvert.getHours() * 60 * 60;
    const minutesInSec = toConvert.getMinutes() * 60;
    const seconds = toConvert.getSeconds();

    return hoursInSec + minutesInSec + seconds;
  }
}
